<!-- <div> -->
<div [ngSwitch]="currentStepIndex">
    <div *ngSwitchCase="0">
        <ng-container>
            <div>
                <app-loading [loadingText]="'Loading...'"></app-loading>
            </div>
        </ng-container>
    </div>

    <div *ngSwitchCase="1">
        <app-moniepoint-failure-modal (closeModal)="closeModal()"
                                      [buttonText]="BENEFICIARY_ERROR_BTN"
                                      [description]="BENEFICIARY_ERROR_DES"
                                      [title]="BENEFICIARY_ERROR">
        </app-moniepoint-failure-modal>
    </div>

    <div *ngSwitchCase="2">
        <div>
            <div>
                <div class="suggested-bank">Suggested Banks</div>
                <div class="m-t-5 select-bank">Select the most suitable bank</div>
            </div>
            <div class="account-details m-t-24" nz-row nzAlign="middle">
                <div>
                  <svg fill="none" height="33" viewBox="0 0 32 33" width="32" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M15.3327 2.26294L2.66602 8.92961V11.5963H27.9993V8.92961L15.3327 2.26294ZM21.3327 14.2629V23.5963H25.3327V14.2629H21.3327ZM2.66602 30.2629H27.9993V26.2629H2.66602V30.2629ZM13.3327 14.2629V23.5963H17.3327V14.2629H13.3327ZM5.33268 14.2629V23.5963H9.33268V14.2629H5.33268Z"
                      fill="#0361F0" />
                  </svg>
                </div>
                <div class="m-l-12">
                    <div class="m-b-0 bank-acc-no-label">Account Number</div>
                    <small class="bank-acc-no">{{accountNumber}}</small>
                </div>
            </div>
        </div>
        <div class="m-t-24">
            <div *ngIf="gettingBanks">
                <app-loading [loadingText]="'Fetching Banks'"></app-loading>
            </div>

            <div *ngIf="!gettingBanks">
                <div *ngFor="let bank of suggestedBanks;let index=index" style="padding-top:20px">
                    <!--          <label [id]="bank.cbncode" nz-row nzJustify="space-between" nzAlign="middle" class="single-bank">-->
                    <!--            {{bank.name}}-->
                    <!--            &lt;!&ndash; <div>-->
                    <!--                <p>{{bank.name}}</p>-->
                    <!--            </div> &ndash;&gt;-->
                    <!--&lt;!&ndash;            <label  name="beneficiary-bank" (nzCheckedChange)="selectBank($event)" [id]="bank.cbncode" nz-checkbox [(ngModel)]="selectedBank"></label>&ndash;&gt;-->
                    <!--            <input type="radio" [id]="bank.cbncode" name="beneficiary-bank" [value]="bank" [(ngModel)]="selectedBank"-->
                    <!--                   (ngModelChange)="selectBank($event)" />-->
                    <!--          </label>-->
                    <div (click)="selectBank(bank)" class="addCursor" nz-row nzAlign="middle" nzJustify="space-between">
                        <div class="bank-label-text">
                            {{bank.name}}
                        </div>
                        <div>
                            <label (ngModelChange)="selectBank(bank)"
                                   [ngModel]="selectedBank?.name === bank.name" nz-radio></label>
                        </div>
                    </div>
                    <div *ngIf="(suggestedBanks.length -1) !== index" style="margin-top: 21px">
                        <div class="bank-form-divider"></div>
                    </div>
                </div>
                <div class="m-t-14" nz-row nzJustify="center">
                    <button (click)="showAllBanks()" class="view-banks">
                       <span>
                         	<svg fill="none" height="25" viewBox="0 0 24 25" width="24" xmlns="http://www.w3.org/2000/svg">
			<path
        d="M11.5 1.5L2 6.5V8.5H21V6.5L11.5 1.5ZM16 10.5V17.5H19V10.5H16ZM2 22.5H21V19.5H2V22.5ZM10 10.5V17.5H13V10.5H10ZM4 10.5V17.5H7V10.5H4Z"
        fill="#0361F0" />
		</svg>
                       </span>
                        <span>View All Banks</span>
                    </button>
                </div>


                <div class="m-t-24">
                    <div nz-row nzAlign="middle" nzJustify="space-between">
                        <div>

                        </div>
                        <div class="float-right" nz-row nzAlign="middle">
                            <div (click)="closeModal()" class="back-btn">
                                Back
                            </div>
                            <div class="m-l-47">
                                <button (click)="accountNameEnquiry()" [disabled]="!selectedBank"
                                        [nzLoading]="submitting"
                                        class="btn btn-primary button-size-102" nz-button>
                                    Next
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div *ngSwitchCase="3">
        <div>
            <div>
                <h2>Select a Bank</h2>
                <p>Which bank does your recipient use?</p>
            </div>

            <div class="custom-floating-input m-t-24">
                <input (ngModelChange)="filterBankList(bankSearchTerm)" [(ngModel)]="bankSearchTerm"
                       class="custom-input" id="account" nz-input
                       placeholder="Search for bank" type="text">
                <label for="account">Search</label>
            </div>
        </div>

        <div class="all-banks-list m-t-24 m-b-24 p-l-10 p-r-10">
            <div *ngFor="let bank of filteredBanks" style="padding-top:20px">
                <div (click)="selectBank(bank)" class="addCursor" nz-row nzAlign="middle" nzJustify="space-between">
                    <div class="bank-label-text">
                        {{bank.name}}
                    </div>
                    <div>
                        <label (ngModelChange)="selectBank(bank)"
                               [ngModel]="selectedBank?.name === bank.name" nz-radio></label>
                    </div>
                </div>
                <div style="margin-top: 21px">
                    <div class="bank-form-divider"></div>
                </div>
            </div>
        </div>
        <div class="m-t-24">
            <div nz-row nzAlign="middle" nzJustify="space-between">
                <div>

                </div>
                <div class="float-right" nz-row nzAlign="middle">
                    <div (click)="closeModal()" class="back-btn">
                        Back
                    </div>
                    <div class="m-l-47">
                        <button (click)="accountNameEnquiry()" [nzLoading]="submitting"
                                class="btn btn-primary button-size-102" nz-button>
                            Next
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngSwitchCase="4">
        <div>
            <div>
                <h3 class="page-title">Beneficiary Found</h3>
                <small>Confirm beneficiary details</small>
            </div>

            <div class="beneficiary-info m-t-24" nz-row nzAlign="middle">
                <div>
                  <svg fill="none" height="48" viewBox="0 0 49 48" width="49" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M30.3956 8.61804C28.8986 6.92973 26.8079 6 24.5001 6C22.1801 6 20.0824 6.92411 18.5924 8.60196C17.0862 10.2983 16.3524 12.6038 16.5247 15.0932C16.8662 20.0046 20.444 24 24.5001 24C28.5563 24 32.1279 20.0054 32.4748 15.0948C32.6495 12.6279 31.911 10.3272 30.3956 8.61804Z"
                      fill="white" />
                    <path
                      d="M38.0381 41.9998H10.9619C10.6075 42.0048 10.2565 41.9241 9.93453 41.7637C9.61252 41.6032 9.32757 41.367 9.10042 41.0723C8.60044 40.4248 8.3989 39.5406 8.54813 38.6465C9.19734 34.7449 11.2234 31.4674 14.408 29.1666C17.2371 27.1242 20.8209 26 24.5 26C28.1791 26 31.7629 27.125 34.592 29.1666C37.7766 31.4666 39.8027 34.744 40.4519 38.6457C40.6011 39.5398 40.3996 40.424 39.8996 41.0715C39.6725 41.3664 39.3876 41.6027 39.0656 41.7633C38.7436 41.9239 38.3926 42.0047 38.0381 41.9998Z"
                      fill="white" />
                  </svg>
                </div>
                <div>
                    <p>{{beneficiaryDetails.account.name}} </p>
                    <small>{{selectedBank.name}} - {{accountNumber}}</small>
                </div>
            </div>
            <div class="add-to-beneficiary m-t-24" nz-row nzJustify="space-between">
                <div nz-row nzAlign="middle">
                    <span>
                      <svg fill="none" height="48" viewBox="0 0 49 48" width="49" xmlns="http://www.w3.org/2000/svg">
			<path
        d="M30.3956 8.61804C28.8986 6.92973 26.8079 6 24.5001 6C22.1801 6 20.0824 6.92411 18.5924 8.60196C17.0862 10.2983 16.3524 12.6038 16.5247 15.0932C16.8662 20.0046 20.444 24 24.5001 24C28.5563 24 32.1279 20.0054 32.4748 15.0948C32.6495 12.6279 31.911 10.3272 30.3956 8.61804Z"
        fill="white" />
			<path
        d="M38.0381 41.9998H10.9619C10.6075 42.0048 10.2565 41.9241 9.93453 41.7637C9.61252 41.6032 9.32757 41.367 9.10042 41.0723C8.60044 40.4248 8.3989 39.5406 8.54813 38.6465C9.19734 34.7449 11.2234 31.4674 14.408 29.1666C17.2371 27.1242 20.8209 26 24.5 26C28.1791 26 31.7629 27.125 34.592 29.1666C37.7766 31.4666 39.8027 34.744 40.4519 38.6457C40.6011 39.5398 40.3996 40.424 39.8996 41.0715C39.6725 41.3664 39.3876 41.6027 39.0656 41.7633C38.7436 41.9239 38.3926 42.0047 38.0381 41.9998Z"
        fill="white" />
		</svg>
                    </span>
                    <p>Add to beneficiaries?</p>
                </div>
                <div>
                    <nz-switch [(ngModel)]="saveBeneficiary"></nz-switch>
                </div>
            </div>
            <nz-divider></nz-divider>
            <div class="m-t-24">
                <div nz-row nzAlign="middle" nzJustify="space-between">
                    <div>

                    </div>
                    <div class="float-right" nz-row nzAlign="middle">
                        <div (click)="goBack()" class="back-btn">
                            Back
                        </div>
                        <div class="m-l-47">
                            <button (click)="saveBeneficiaryInformation()" [nzLoading]="submitting"
                                    class="btn btn-primary button-size-152" nz-button>Confirm
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
